// Angular
import { Component, Input, OnInit } from '@angular/core';
// Lodash
import { shuffle } from 'lodash';

export interface Widget1Data {
	title: string;
	desc: string;
	value: string;
	valueClass?: string;
}

@Component({
	selector: 'kt-widget1',
	templateUrl: './widget1.component.html',
	styleUrls: ['./widget1.component.scss']
})
export class Widget1Component implements OnInit {
	// Public properties
	@Input() data: Widget1Data[];

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		if (!this.data) {
			this.data = shuffle([
				{
					title: 'Available Space ',
					desc: 'Available Vacant Housemanship',
					value: '400',
					valueClass: 'kt-font-brand'
				}, {
					title: 'MDCN Quota',
					desc: 'MDCN Quota',
					value: '40',
					valueClass: 'kt-font-danger'
				}, {
					title: 'Center Quota',
					desc: 'Training Center Quota',
					value: '120',
					valueClass: 'kt-font-success'
				}
			]);
		}
	}

}
